import { useMediaQuery } from 'react-responsive';


export const useTabletOrMobile = () => useMediaQuery({ query: '(max-width: 750px)' });
